import { useFn } from '@eturi/react'
import { memo } from 'react'
import { useSelector } from 'react-redux'
import { pairModalData$, setPairModal } from '../../reducers/pair.slice'
import { useAppDispatch } from '../../types'
import PairDeviceModal from './PairDeviceModal'
import QuickPairModal from './QuickPairModal'

const PairingModal = () => {
	const d = useAppDispatch()
	const pairModalData = useSelector(pairModalData$)

	const handleModalClose = useFn(() => d(setPairModal(null)))

	if (!pairModalData) return null

	const { feature, type } = pairModalData

	if (type == 'quick_pair') return <QuickPairModal onClose={handleModalClose} />

	return (
		<PairDeviceModal
			feature={feature}
			showQuickPair={type == 'pairing_options'}
			onClose={handleModalClose}
		/>
	)
}

export default /*@__PURE__*/ memo(PairingModal)
